import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  Grid,
  Alert
} from '@mui/material';
import { ZoomField } from './ZoomField';
import { BlobticZoomPopup } from './BlobticZoomPopup';
import { useBlobticZoom } from '../hooks/useBlobticZoom';
import { ZoomData } from '../services/blobticZoomService';

export const ZoomTestSimple: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [agencyCode, setAgencyCode] = useState('');
  const [testLog, setTestLog] = useState<string[]>([]);

  // Hook pour gérer le zoom
  const {
    openZoom,
    closeZoom,
    isOpen,
    currentZoomKey,
    currentDynamicParams
  } = useBlobticZoom();

  const handleAgencyChange = (value: string, selectedData?: ZoomData) => {
    setAgencyCode(value);
    if (selectedData) {
      setTestLog(prev => [...prev, `✅ Agence sélectionnée: ${selectedData.DOS_LIB} (${selectedData.DOS_CODE})`]);
    }
  };

  const handleZoomOpen = () => {
    setTestLog(prev => [...prev, `🔍 Tentative d'ouverture du zoom avec email: ${email}, password: ${password ? '***' : 'VIDE'}`]);
    
    // Ouvrir le zoom des agences avec les paramètres de connexion
    openZoom('dossier', {
      USER_MAIL: email,
      USER_PASS: password
    });
  };

  const handleZoomSelect = (selectedData: ZoomData) => {
    handleAgencyChange(selectedData.DOS_CODE || '', selectedData);
  };

  const isZoomDisabled = !email || !password;

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4, p: 2 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" component="h1" gutterBottom align="center">
          Test Simple - Bouton Zoom
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, textAlign: 'center' }}>
          Testez le bouton zoom avec validation des paramètres
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="test@example.com"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Mot de passe"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="test123"
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              <strong>État du bouton zoom :</strong> {isZoomDisabled ? '🔴 DÉSACTIVÉ' : '🟢 ACTIVÉ'}
            </Typography>
            <ZoomField
              zoomKey="dossier"
              label="Code d'agence"
              placeholder="Cliquez sur le bouton zoom"
              value={agencyCode}
              onChange={handleAgencyChange}
              displayField="DOS_CODE"
              valueField="DOS_IDF"
              fullWidth
              onZoomOpen={handleZoomOpen}
              zoomDisabled={isZoomDisabled}
              zoomDisabledMessage="Remplissez d'abord l'email et le mot de passe"
            />
          </Grid>

          {agencyCode && (
            <Grid item xs={12}>
              <Alert severity="success">
                <Typography variant="body2">
                  <strong>Code d'agence sélectionné :</strong> {agencyCode}
                </Typography>
              </Alert>
            </Grid>
          )}

          {testLog.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mb: 2 }}>Log des tests :</Typography>
              <Paper variant="outlined" sx={{ p: 2, maxHeight: 200, overflow: 'auto' }}>
                {testLog.map((log, index) => (
                  <Typography key={index} variant="body2" sx={{ mb: 0.5 }}>
                    {log}
                  </Typography>
                ))}
              </Paper>
            </Grid>
          )}
        </Grid>
      </Paper>

      {/* Popup de zoom */}
      <BlobticZoomPopup
        open={isOpen}
        zoomKey={currentZoomKey || ''}
        dynamicParams={currentDynamicParams}
        onClose={closeZoom}
        onSelect={handleZoomSelect}
        title="Sélection d'agence"
      />
    </Box>
  );
};
